import { defineStore } from 'pinia'
import { useId } from 'vue'
import useGet from '../core/composables/api/useGet'
import type { Team } from '../core/models/team/team'
import { useEventBus } from '@vueuse/core'
import { EventKey } from '../core/events/event-key'
import { ApiRequestStatus } from '../core/models/api/api-request-status'

export const useTeamsStore = defineStore('teams', {
  state: () => ({
    _teams: new Map<string, Team>(),
  }),

  getters: {
    allTeams(state) {
      return [...state._teams.values()]
    },
  },
  actions: {
    getTeamById(id: string) {
      const team = this._teams.get(id)
      if (team) {
        return team
      }

      return {
        id: 'unknown' + useId(),
        name: 'unknown',
      }
    },
    initialize() {
      this.reload()
      useEventBus(EventKey.teamCreated).on(() => {
        this.reload()
      })
      useEventBus(EventKey.teamUpdated).on(() => {
        this.reload()
      })
    },
    async reload() {
      const { load, data: teams, status } = useGet<Team[]>('teams')
      await load()
      if (status.value !== ApiRequestStatus.Success || !teams.value) {
        return
      }
      this._teams.clear()
      for (const team of teams.value) {
        this._teams.set(team.id, team)
      }
    },
  },
})
